import type ExcelJS from 'exceljs';
import { XLSX_MIME_TYPE } from '../exportsPage.definitions';

/** Gera o arquivo .xlsx no browser e dispara o download. */
export async function downloadWorkbook(
    workbook: ExcelJS.Workbook,
    fileName: string
): Promise<void> {
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: XLSX_MIME_TYPE });
    const url = window.URL.createObjectURL(blob);

    try {
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = fileName;
        anchor.click();
    } finally {
        window.URL.revokeObjectURL(url);
    }
}
